import React, { useEffect, useState } from 'react'
import InputField from './ui/InputField'
import TextAreaField from './ui/TextAreaField';
import Chip from './ui/Chip';
import FilledButton from './ui/FilledButton';
import Select from './ui/Select';
import FormButton from './ui/FormButton';
import OutlinedButton from './ui/OutlinedButton';
import { useNavigate, useParams } from 'react-router-dom';
import { updateCourse } from '../services/api/courses/updateCourse';
import { getCourseById } from '../services/api/courses/getCourse';

const EditCourseForm = () => {
  const [course, setCourse] = useState({ title:"",description:"" });
  const [interests, setInterests] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [newInterest, setNewInterest] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    // console.log(params.courseId);
    setIsLoading(true);
    getCourseById(params.courseId).then(response => {
        console.log(response);
        if (response.error === null) {
            setCourse({ title:response.data.title, description:response.data.description });
            setInterests(response.data.interests);
            setChallenges(response.data.challenges.map(val => ({ id:val.challenge_id,title:val.title })));
            setIsLoading(false);
        }
    });
  },[params.courseId]);

  const handleChange = (e) => {
    const { name,value } = e.target;
    setCourse(prev => ({...prev,[name]: value}));
  };

  const handleRemove = (chipToRemove) => {
    setInterests(interests.filter((chip) => chip !== chipToRemove));
  };

  const handleAddChip = () => {
    if (newInterest && !interests.includes(newInterest)) {
      setInterests([...interests, newInterest]);
      setNewInterest(''); // Clear input after adding
    }
  };

  const handleClear = () => {
    setChallenges([]);
    setCourse({ title:"" , description:""});
    setInterests([]);
  }

  const handleCancel = () => { handleClear(); navigate(-1);}; 

  const handleSubmit = (e) => {
    e.preventDefault();
    if (interests.length !== 0 && challenges.length !== 0 && course.title.trim().length !== 0 && course.description.trim().length !== 0) {
      setIsLoading(true);
      updateCourse(params.courseId,interests,challenges.map(val => val.id),course.title,course.description).then(response => {
        if (!(response.error === null)) {
          alert('an error');
        }else{
          alert('course updated');
        }
      }).finally(() => {
        setIsLoading(false);
        handleCancel();
      });
    }else{
      alert('fill all the details');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key.toLowerCase() === 'enter') {
      e.preventDefault();
      handleAddChip();
    }
  }

  const handleReturnValue = (challengeId,challengeTitle) => {
    if (challengeId && challengeTitle) {
      for (let i = 0; i < challenges.length; i++) {
        const element = challenges[i];
        if (element.id === challengeId) {
          return 0;
        }
      }
      setChallenges(prev => [...prev,{ id:challengeId, title:challengeTitle }]);
    }
  }

  const handleRemoveChallenge = (challengeId) => {
    setChallenges(challenges.filter((chip) => chip.id !== challengeId));
  }
 
  return (
    <div className='flex justify-center'>
    {course.title.length === 0?"Loading...":<form method='POST' className='flex flex-col gap-4 min-w-full sm:min-w-[650px] sm:max-w-[650px]' onSubmit={handleSubmit}>
        <p className='text-lg font-semibold text-blue-500 text-center'>Edit Course</p>
    <InputField
        label="Course Title"
        name="title"
        value={course.title}
        onChange={handleChange}
        required={true}
        placeholder="Enter a course title"
      />
        <TextAreaField
        label="Course Description"
        name="description"
        value={course.description}
        onChange={handleChange}
        placeholder="Enter a detailed description of course"
        rows={6}  
        required={true}
      />
      <div className='flex gap-1'>
      <InputField
        label="Interests"
        name="interests"
        value={newInterest}
        onChange={(e) => setNewInterest(e.target.value)}
        placeholder="Enter a interest area for the course"
        className="flex-1"
        onKeyDown={handleKeyDown}
        />
      <FilledButton label={'Add'} onClick={handleAddChip} className={'self-end'} />
        </div>
      <div className="flex gap-2 flex-wrap">
      {interests.map((interest, index) => (
        <Chip
          key={index}
          label={interest}
          removable={true}
          onRemove={() => handleRemove(interest)}
        />
      ))}
    </div>
    <Select handleReturnValue={handleReturnValue} />
    <div className="flex gap-2 flex-wrap">
      {challenges.map((challenge, index) => (
        <Chip
          key={index}
          label={challenge.title}
          removable={true}
          onRemove={() => handleRemoveChallenge(challenge.id)}
        />
      ))}
    </div>
    <div className='flex items-center gap-2 justify-end'>
    <OutlinedButton label={'cancel'} onClick={handleCancel} />
    <FormButton
        label={isLoading ? 'Updating...' : 'Update Course'}
        type={'submit'}
        disabled={isLoading}
        />
        </div>
    </form>}
    </div>
  )
}

export default EditCourseForm